import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const ChildPosEdit = ({
  childPosInfo,
  handleChangeField,
  handleDropDownChangeEdit,
  error,
  readOnly,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSLegalName"
          label={t(`Legal Name`)}
          InputLabelProps={{ shrink: true }}
          size="small"
          onChange={handleChangeField}
          // fullWidth
          disabled={readOnly}
          value={childPosInfo.POSLegalName || ""}
          error={error.POSLegalName ? true : false}
          helperText={t(error.POSLegalName)}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSStreet"
          label={t(`Street`)}
          // fullWidth
          disabled={readOnly}
          InputLabelProps={{ shrink: true }}
          size="small"
          onChange={handleChangeField}
          value={childPosInfo.POSStreet || ""}
          error={error.POSStreet ? true : false}
          helperText={t(error.POSStreet)}
        />
      </Grid>

      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSStreetNumber"
          label={t(`Street Number`)}
          InputLabelProps={{ shrink: true }}
          size="small"
          onChange={handleChangeField}
          disabled={readOnly}
          value={childPosInfo.POSStreetNumber || ""}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSCity"
          label={t(`Pos City`)}
          InputLabelProps={{ shrink: true }}
          size="small"
          onChange={handleChangeField}
          value={childPosInfo.POSCity || ""}
          error={error.POSCity ? true : false}
          helperText={t(error.POSCity)}
          disabled={readOnly}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSDistrict"
          label={t(`District`)}
          InputLabelProps={{ shrink: true }}
          size="small"
          onChange={handleChangeField}
          value={childPosInfo.POSDistrict || ""}
          error={error.POSDistrict ? true : false}
          helperText={t(error.POSDistrict)}
          disabled={readOnly}
        />
      </Grid>
      <Grid item sm={4}>
        <Autocomplete
          name="POS_StateSK"
          options={childPosInfo?.state || []}
          value={childPosInfo}
          disabled={readOnly}
          getOptionLabel={(option) => option.stateDescription || ""}
          renderOption={(option) => <span>{option.stateDescription}</span>}
          onChange={(event, value) =>
            handleDropDownChangeEdit(
              event,
              value,
              "POS_StateSK",
              "stateSK",
              "stateDescription"
            )
          }
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              style={{ maxWidth: 225 }}
              InputLabelProps={{ shrink: true }}
              label={t(`State`)}
              variant="outlined"
              error={error.POS_StateSK ? true : false}
              helperText={t(error.POS_StateSK)}
            />
          )}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSZipCode"
          label={t(`Zip Code`)}
          InputLabelProps={{ shrink: true }}
          size="small"
          inputProps={{ min: 0 }}
          onChange={handleChangeField}
          disabled={readOnly}
          value={childPosInfo.POSZipCode || ""}
          error={error.POSZipCode ? true : false}
          helperText={t(error.POSZipCode)}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSTaxID"
          label={t(`Tax ID`)}
          InputLabelProps={{ shrink: true }}
          size="small"
          onChange={handleChangeField}
          value={childPosInfo.POSTaxID || ""}
          error={error.POSTaxID ? true : false}
          helperText={t(error.POSTaxID)}
          disabled={readOnly}
        />
      </Grid>
      <Grid item sm={4}>
        <Autocomplete
          name="POS_TaxCategorySK"
          options={childPosInfo?.taxcategory || []}
          value={childPosInfo}
          getOptionLabel={(option) => option.taxcategoryDescription || ""}
          renderOption={(option) => (
            <span>{option.taxcategoryDescription}</span>
          )}
          disabled={readOnly}
          onChange={(event, value) =>
            handleDropDownChangeEdit(
              event,
              value,
              "POS_TaxCategorySK",
              "taxcategorySK",
              "taxcategoryDescription"
            )
          }
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              style={{ maxWidth: 225 }}
              InputLabelProps={{ shrink: true }}
              label={t(`Tax Category`)}
              variant="outlined"
              error={error.POS_TaxCategorySK ? true : false}
              helperText={t(error.POS_TaxCategorySK)}
            />
          )}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSXCoordinate"
          label={t(`X Coordinate`)}
          InputLabelProps={{ shrink: true }}
          size="small"
          disabled={readOnly}
          onChange={handleChangeField}
          value={childPosInfo.POSXCoordinate || ""}
          error={error.POSXCoordinate ? true : false}
          helperText={t(error.POSXCoordinate)}
        />
      </Grid>

      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSYCoordinate"
          label={t(`Y Coordinate`)}
          InputLabelProps={{ shrink: true }}
          size="small"
          onChange={handleChangeField}
          disabled={readOnly}
          value={childPosInfo.POSYCoordinate || ""}
          error={error.POSYCoordinate ? true : false}
          helperText={t(error.POSYCoordinate)}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          select
          variant="outlined"
          name="POSStatus"
          label={t(`Status`)}
          size="small"
          value={childPosInfo.POSStatus}
          onChange={handleChangeField}
          disabled={readOnly}
          style={{ minWidth: 220 }}
          InputLabelProps={{ shrink: true }}
        >
          <MenuItem value="A">Active</MenuItem>
          <MenuItem value="I">Inactive</MenuItem>
        </TextField>
      </Grid>
    </>
  );
};

export default ChildPosEdit;

ChildPosEdit.propTypes = {
  childPosInfo: PropTypes.object,
  handleChangeField: PropTypes.func,
  handleDropDownChangeEdit: PropTypes.func,
  error: PropTypes.object,
  readOnly: PropTypes.bool,
};
